/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_card_enterprise_security_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account safety is our priority. Industry-standard encryption keeps your data safe.`)
};

const zh_hans1_card_enterprise_security_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的账户安全是我们的首要任务。采用行业标准加密技术保护您的数据。`)
};

const zh_hant1_card_enterprise_security_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的帳戶安全是我們的首要任務。採用業界標準加密技術保護您的資料。`)
};

const fr_card_enterprise_security_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sécurité de votre compte est notre priorité. Le chiffrement aux standards de l’industrie protège vos données.`)
};

const de_card_enterprise_security_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Kontosicherheit hat Priorität. Branchenübliche Verschlüsselung schützt deine Daten.`)
};

const ja_card_enterprise_security_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントの安全を最優先に。業界標準の暗号化でデータを守ります。`)
};

const ko_card_enterprise_security_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 보안이 최우선입니다. 업계 표준 암호화로 데이터를 안전하게 보호합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const card_enterprise_security_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.card_enterprise_security_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("card_enterprise_security_desc", locale)
	if (locale === "en") return en_card_enterprise_security_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_card_enterprise_security_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_card_enterprise_security_desc(inputs)
	if (locale === "fr") return fr_card_enterprise_security_desc(inputs)
	if (locale === "de") return de_card_enterprise_security_desc(inputs)
	if (locale === "ja") return ja_card_enterprise_security_desc(inputs)
	return ko_card_enterprise_security_desc(inputs)
};